module.exports = __webpack_public_path__ + "img/img_about_1.adcba737.jpg";